import React from 'react';
import { Booking } from '../../types';
import CheckIcon from '../icons/CheckIcon';
import { BookingDataView, BookingDataViewType } from './BookingDataView';
import { getConfirmationString } from './strings';

interface BookingConfirmationProps {
    confirmationData: Booking;
    closeConfirmation: () => void;
    rescheduleBooking: () => void;
    setCancelBookingId: (bookingId: string) => void;
}

const BookingConfirmation = ({
    confirmationData,
    closeConfirmation,
    rescheduleBooking,
    setCancelBookingId,
}: BookingConfirmationProps) => (
    <BookingDataView
        bookingData={confirmationData}
        dataAuto='booking-confirmation-screen'
        onClose={closeConfirmation}
        type={BookingDataViewType.SUCCESS}
        title={getConfirmationString('title')}
        svgIcon={<CheckIcon />}
    >
        <label>{getConfirmationString('change')}</label>
        <span
            onClick={rescheduleBooking}
            data-auto='booking-confirmation-reschedule-button'
        >
            {getConfirmationString('reschedule')}
        </span>
        <label>{getConfirmationString('or')}</label>
        <span
            onClick={() => {
                setCancelBookingId(confirmationData.uid);
                closeConfirmation();
            }}
            data-auto='booking-confirmation-cancel-button'
        >
            {getConfirmationString('cancel')}
        </span>
    </BookingDataView>
);

export default BookingConfirmation;
